import axios from 'axios';

export default {
  state: {
    list: [],
  },
  actions: {
    getPendingBulkUploads() {
      return axios.get('/api/v2/documents/bulk/');
    },
  },
  mutations: {
    setPendingBulkUploads(state, bulkUploads) {
      state.list = bulkUploads;
    },
    addPendingBulkUpload(state, bulkUpload) {
      state.list = [...state.list, bulkUpload];
    },
    updatePendingBulkUpload(state, update) {
      const uploads = [...state.list];
      const uploadIndex = uploads.findIndex(
        (upload) => upload.uploadId === update.uploadId,
      );

      uploads[uploadIndex] = {
        ...uploads[uploadIndex],
        ...update,
      };

      state.list = uploads;
    },
  },
};
